import { ModalContent } from '@/components/Modal'
import { useConfigureController } from '../hooks/useController'
import { Body } from './Body'
import { Footer } from './Footer'
import { Header } from './Header'

interface Props {
  depotIds: string[]
}

export function Content(props: Props) {
  const { ready } = useConfigureController(props)

  if (!ready) return null

  return (
    <ModalContent header={<Header />} footer={<Footer />}>
      <Body />
    </ModalContent>
  )
}
